"use client";

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcn-components/ui/dialog";
import { Button } from "@/shadcn-components/ui/button";
import { useSettingsStore } from "@/lib/settings";

interface OneClickTradingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
}

export function OneClickTradingDialog({
  open,
  onOpenChange,
  onConfirm,
}: OneClickTradingDialogProps) {
  const { updateSetting } = useSettingsStore();

  const handleTurnOn = () => {
    updateSetting("oneClickTrading", true);
    onOpenChange(false);
    onConfirm?.();
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>One-Click Trading Required</DialogTitle>
          <DialogDescription>
            To perform trading actions, you need to enable One-Click Trading.
            This allows you to execute trades without additional confirmation
            dialogs.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-3">
          <Button variant="outline" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleTurnOn}>Turn On</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
